import React from "react";
import { motion } from "framer-motion";
import { fadeIn } from "./motionUtils";
import { resume } from "../data/resume";

export const Skills = () => {
  return (
    <div className="font-thin w-full text-sm sm:text-base font-lora">
      {resume.skills.map((skill, index) => {
        return (
          <motion.div
            variants={fadeIn("right", "tween", 0, 1.5)}
            whileInView="show"
            initial="hidden"
            viewport={{ once: false, amount: 0.05 }}
            className="w-full"
            key={index}
          >
            <li>
              <span className="space-x-1">
                <span className="font-semibold">{`${skill.name}`}</span>
                <span>
                  <i>{`(${skill.years_of_exp} years)`}</i>
                </span>
              </span>
            </li>
          </motion.div>
        );
      })}
      <br />
      <br />
      <br />
    </div>
  );
};
